import { render, staticRenderFns } from "./BtnFiltro.vue?vue&type=template&id=5b231e8a"
import script from "./BtnFiltro.vue?vue&type=script&lang=js"
export * from "./BtnFiltro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports